import ReactMarkdown from 'react-markdown';
import { rehypeBrToNewline } from './util';
import { ReactMarkdownOptions } from 'react-markdown/lib/react-markdown';

const blockLevelElements = [
  'aside',
  'blockquote',
  'div',
  'dl',
  'figure',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'li',
  'nav',
  'ul',
  'ol',
  'p',
  'section',
  'table',
];

export interface MarkdownProps extends Omit<ReactMarkdownOptions, 'disallowedElements'> {}

export const Markdown = (props: MarkdownProps) => {
  return (
    <ReactMarkdown
      rehypePlugins={[rehypeBrToNewline]}
      disallowedElements={blockLevelElements}
      unwrapDisallowed={true}
      {...props}
    />
  );
};
